import { MapPin, Clock, Phone } from "lucide-react";
import Reveal from "@/components/Reveal";
import { CONTENT } from "@/content";

const INFO = [
  { icon: MapPin, label: "Adresse", value: CONTENT.address, testid: "cabinet-address" },
  { icon: Phone, label: "Téléphone", value: CONTENT.phone, testid: "cabinet-phone" },
];

const Cabinet = () => (
  <section id="cabinet" className="grain bg-beige-cream py-28 md:py-36" data-testid="cabinet-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-12 lg:px-12">
      <div className="relative order-2 lg:order-1 lg:col-span-6" data-testid="cabinet-visual">
        <Reveal className="relative">
          <div className="blob absolute -right-8 -top-8 h-3/4 w-3/4 bg-sage-pale" />
          <img
            src={CONTENT.images.cabinet}
            alt={CONTENT.images.cabinetAlt}
            loading="lazy"
            className="soft-shadow relative aspect-[4/5] w-full rounded-xl object-cover"
          />
        </Reveal>
        <Reveal delay={0.2} className="relative z-10 -mt-20 ml-auto w-2/3 md:-mt-28">
          <img
            src={CONTENT.images.cabinetSecond}
            alt={CONTENT.images.cabinetSecondAlt}
            loading="lazy"
            className="soft-shadow aspect-[4/5] w-full rounded-xl border-8 border-beige-cream object-cover"
          />
        </Reveal>
      </div>

      <div className="order-1 lg:order-2 lg:col-span-6 lg:pl-8">
        <Reveal>
          <p className="text-xs font-medium uppercase tracking-[0.28em] text-gold">Le cabinet</p>
          <h2 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight text-anthracite md:text-5xl">
            Un lieu calme, pensé pour votre <em className="text-sage-dark">détente</em>
          </h2>
          <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-taupe">
            Lumière naturelle, matériaux doux, atmosphère apaisée : le cabinet
            a été imaginé comme une parenthèse. Ici, on prend le temps — de
            vous écouter, de vous expliquer, de vous soigner.
          </p>
        </Reveal>

        <div className="mt-12 space-y-7">
          {INFO.map((item, i) => (
            <Reveal key={item.label} delay={i * 0.1}>
              <div className="flex items-start gap-5" data-testid={item.testid}>
                <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-sage-light/70 bg-ivory">
                  <item.icon className="h-5 w-5 text-sage-dark" strokeWidth={1} />
                </span>
                <div>
                  <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-taupe/70">{item.label}</p>
                  <p className="mt-1 font-serif text-xl text-anthracite">{item.value}</p>
                </div>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.3}>
            <div className="flex items-start gap-5" data-testid="cabinet-hours">
              <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-sage-light/70 bg-ivory">
                <Clock className="h-5 w-5 text-sage-dark" strokeWidth={1} />
              </span>
              <div>
                <p className="text-[11px] font-medium uppercase tracking-[0.22em] text-taupe/70">Horaires</p>
                <ul className="mt-2 space-y-1.5">
                  {CONTENT.hours.map((h) => (
                    <li key={h.day} className="flex items-baseline gap-4">
                      <span className="w-20 font-serif text-lg text-anthracite">{h.day}</span>
                      <span className="text-sm font-light text-taupe">{h.time}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Cabinet;
